<script>
import options from "./ForumEditProfile.options";
export default options;
</script>

<template>
  <article class="kb-stafet-donation-flow kb-forum-edit-profile">
    <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
      <div class="kb-stafet-step__divider"></div>

      <ProfilePicture :content="activeProfilePicture" :userId="content.id" :hasProfileImage="hasProfilePicture"
        type="cancerforum"></ProfilePicture>

      <div class="kb-stafet-step__divider"></div>

      <div class="kb-stafet-step__input-wrapper">

        <h2 class="kb-stafet-step__step-section-title">
          {{ getLabel("aboutSectionTitle") }}
        </h2>
        <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
          <FormInputNameField isRequired v-model="personalInfo.ProfileName" :modelValue="personalInfo.ProfileName"
            fieldName="cancerForumName" :label="getLabel('cancerForumNameLabel')" :isValidationError="displayError && !nameValidator(personalInfo.ProfileName)
              " :placeholder="getLabel('cancerForumNamePlaceholder')"
            :errorMessageLabel="getLabel('cancerForumNameError')" />

          <FormInputDropdown v-model="personalInfo.relationToCancer" fieldName="relationToCancer"
            :modelValue="personalInfo.relationToCancer" :label="getLabel('relationToCancerLabel')"
            :placeholder="getLabel('relationToCancerPlaceholder')" :selectOptions="content.relationToCancerOptions"
            :onChangeCallback="(e) => (personalInfo.relationToCancer = e.target.value)
              " />
        </div>
      </div>

      <div class="kb-stafet-step__input-wrapper">
        <DropdownWithTags v-model="personalInfo.cancerType" fieldName="cancerType" :isRequired="false"
          :modelValue="personalInfo.cancerType" :label="getLabel('cancerTypeLabel')" :tagsTitle="getLabel('tagsTitle')"
          :placeholder="getLabel('cancerTypePlaceholder')" :selectOptions='{ "options": content.cancerTypeOptions }'
          :onChangeCallback="(tags) => setCancerTypes(tags)" :initTags="personalInfo.cancerType" />

      </div>

      <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">
        <FormInputDropdown v-model="personalInfo.region" fieldName="region" :modelValue="personalInfo.region"
          :label="getLabel('regionLabel')" :placeholder="getLabel('regionPlaceholder')"
          :selectOptions="content.regionOptions" :onChangeCallback="(e) => personalInfo.region = e.target.value" />

        <FormInputTextField v-model="personalInfo.dateOfBirth" fieldName="dateOfBirth"
          :modelValue="personalInfo.dateOfBirth" type="date" :label="getLabel('dateOfBirthLabel')"
          :placeholder="getLabel('dateOfBirthPlaceholder')" />
      </div>

      <div class="kb-stafet-step__input-wrapper">
        <FormInputDropdown v-model="personalInfo.gender" fieldName="gender" :modelValue="personalInfo.gender"
          :label="getLabel('genderLabel')" :placeholder="getLabel('genderPlaceholder')" :selectOptions="genderOptions"
          :onChangeCallback="(e) => (personalInfo.gender = e.target.value)" />

      <editor
        v-if="editorReady"
        :model-value="personalInfo.description"
        @update:modelValue="val => (personalInfo.description = val)"
        :init="{
          plugins: 'emoticons autoresize',
          toolbar: 'emoticons',
          menubar: false,
          statusbar: false,
          branding: false,
          contextmenu: false,
          paste_as_text: true,
          valid_elements: 'p,br',
          forced_root_block: 'p',
          content_style: 'p { margin: 0; }',
          resize: false,
          height: null,
          min_height: 300,
          autoresize_bottom_margin: 0,
        }"
      />


        <nav class="kb-stafet-flow-actions">
          <div class="kb-stafet-flow-actions__buttons-left-wrapper">
            <button class="kb-button kb-button--full-color-spot" :class="{
              'kb-button--disabled': isSubmitting
            }" v-on:click="saveProfile">
              {{ getLabel("saveButton") }}
            </button>

            <button class="kb-link" aria-haspopup="true" v-on:click="startUserInfoOverlay">
              {{ getLabel("userOverlayText") }}
            </button>
          </div>
        </nav>
      </div>

      <div class="kb-stafet-step__divider"></div>

      <div class="kb-stafet-step__input-wrapper">
        <h5 class="kb-stafet-step__step-section-title">
          {{ getLabel("notificationsSectionTitle") }}
        </h5>
        <div class="kb-stafet-step__input-wrapper-form-checkboxes">
          <p class="kb-stafet-step__input-wrapper-form-checkboxes-help-text">
            {{ getLabel("notificationsCheckboxTitle") }}
          </p>

          <FormCheckbox fieldName="postInGroup" :modelValue="personalInfo.NotificationForNewPostInMyGroups.toString()"
            v-model="personalInfo.NotificationForNewPostInMyGroups" :label="getLabel('postInGroupLabel')"
            :onChangeCallback="(e) => (personalInfo.NotificationForNewPostInMyGroups = e.target.checked)" />

          <FormCheckbox fieldName="privateMessage" :modelValue="personalInfo.NotificationForDirectMessage.toString()"
            v-model="personalInfo.NotificationForDirectMessage" :label="getLabel('privateMessageLabel')"
            :onChangeCallback="(e) => (personalInfo.NotificationForDirectMessage = e.target.checked)" />

          <FormCheckbox fieldName="commentOnMyPost"
            :modelValue="personalInfo.NotificationForCommentOnMySavedPosts.toString()"
            v-model="personalInfo.NotificationForCommentOnMySavedPosts" :label="getLabel('commentOnMyPostLabel')"
            :onChangeCallback="(e) => (personalInfo.NotificationForCommentOnMySavedPosts = e.target.checked)" />

          <FormCheckbox fieldName="commentInMyGroups"
            :modelValue="personalInfo.NotificationForNewCommentInMyGroups.toString()"
            v-model="personalInfo.NotificationForNewCommentInMyGroups" :label="getLabel('commentInMyGroupsLabel')"
            :onChangeCallback="(e) => (personalInfo.NotificationForNewCommentInMyGroups = e.target.checked)" />
        </div>

        <FormInputDropdown isRequired v-model="personalInfo.NotificationFrequency" fieldName="frequency"
          :modelValue="personalInfo.NotificationFrequency" :label="getLabel('frequencyLabel')" :isValidationError="displayError && !nonEmptyStringValidator(personalInfo.NotificationFrequency)
            " :placeholder="getLabel('frequencyPlaceholder')" :errorMessageLabel="getLabel('frequencyError')"
          :selectOptions="notificationfrequencyOptions"
          :onChangeCallback="(e) => (personalInfo.NotificationFrequency = e.target.value)" />

        <nav class="kb-stafet-flow-actions">
          <div class="kb-stafet-flow-actions__buttons-left-wrapper">
            <button class="kb-button kb-button--full-color-spot" :class="{
              'kb-button--disabled': isSubmitting
            }" v-on:click="saveProfile">
              {{ getLabel("saveButton") }}
            </button>
          </div>
        </nav>
      </div>

      <div class="kb-stafet-step__divider"></div>

      <div class="kb-stafet-step__input-wrapper">

        <h5 class="kb-stafet-step__step-section-title">
          {{ getLabel("userSettingsSectionTitle") }}
        </h5>

        <div class="kb-stafet-step__input-wrapper">

          <div class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half">

            <FormInputEmailField disabled isRequired v-model="content.email" :modelValue="content.email"
              fieldName="cancerForumEmail" :label="getLabel('cancerForumUserEmailLabel')"
              :placeholder="getLabel('cancerForumUserEmailPlaceholder')" />

            <FormInputTextField readOnly isRequired v-model="personalInfo.ProfileName"
              :modelValue="personalInfo.ProfileName" fieldName="cancerForumUserPassword"
              :label="getLabel('cancerForumUserPasswordLabel')" type="password"
              :placeholder="getLabel('cancerForumUserPasswordPlaceholder')" />

          </div>

        </div>

        <nav class="kb-stafet-flow-actions">
          <div class="kb-stafet-flow-actions__buttons-left-wrapper">
            <a :href="changePasswordUrl"
              class="kb-link kb-stafet-flow-actions__link kb-stafet-flow-actions__link--text-link-color">
              {{ getLabel("cancerForumUserChangePasswordLinkText") }}
              <div class="kb-stafet-flow-actions__link-arrow" aria-hidden="true">
                <svg width="17" height="10" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation">
                  <g stroke="#E8001D">
                    <path d="m12.167 1 3.623 4-3.623 4" stroke-linejoin="round" />
                    <path d="M11.746 5H0" />
                  </g>
                </svg>
              </div>
            </a>
          </div>
        </nav>

      </div>

      <!-- delete profile -->
      <div class="kb-forum-edit-profile__delete">
        <p class="kb-forum-edit-profile__delete-text">
          {{ getLabel("deleteText") }}
          <!-- needs to open delete modal CF13 -->
          <span class="kb-forum-edit-profile__delete-link kb-link" aria-haspopup="true" @click="startDeleteUserOverlay">
            {{ getLabel("deleteButtonText") }}
          </span>
        </p>
      </div>
    </section>
  </article>
</template>
